export const HOME_CLEAR_MAINMENU_ACTIVE = "HOME_CLEAR_MAINMENU_ACTIVE";
export const HOME_SET_MAINMENU_ACTIVE = "HOME_SET_MAINMENU_ACTIVE";
export const HOME_SET_SUBMENU_OPENED = "HOME_SET_SUBMENU_OPENED";
